// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../imageSize.fragment.generated';
export const ComponentRoundedImageFragmentDoc = `
    fragment componentRoundedImage on ComponentRoundedImage {
  backgroundColor
  backgroundImageColor
  backgroundImage {
    ...cmsImageSizes
  }
  roundedImage {
    ...cmsImageSizes
  }
}
    `;